import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { SharedDataService } from "../../../../@core/service/shared-data.service";

@Component({
  selector: "ngx-doc-form-multiselect",
  templateUrl: "./doc-form-multiselect.component.html",
  styleUrls: ["./doc-form-multiselect.component.scss"],
})
export class DocFormMultiselectComponent {

  @Input() options = [];
  @Input() value: string[];
  @Input() placeholder: string;
  @Input() checkbox = false;
  @Input() multi = true;
  @Input() maxSelectedItems = undefined;
  @Output() valueChange = new EventEmitter<string[]>();

  lines = [['']];

  constructor() {}

  getLines(item: string) {
    return item.split('||');
  }

  onValueChange(value: string[]) {
    this.valueChange.emit(value);
  }
}
